import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useLang } from '../lib/useLang'

export default function IntegrationsCallback() {
  const navigate = useNavigate()
  const { t } = useLang()

  useEffect(() => {
    const timer = setTimeout(() => navigate('/settings/integrations', { replace: true }), 2000)
    return () => clearTimeout(timer)
  }, [navigate])

  return (
    <div className="flex flex-col items-center justify-center p-12 gap-4">
      <span className="loading loading-spinner loading-lg" />
      <p className="text-lg">{t('integrationsPage.connecting')}</p>
    </div>
  )
}
